import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { useShepherd } from 'react-shepherd';
import { getTourSteps } from '../tour/ShephredTour';
import { SgwtHelpCenter } from '@sgwt/sgwt-widgets-react';

export const HelpCenter = () => {
  const { Tour } = useShepherd();
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();

  const startTour = () => {
    const steps = getTourSteps(intl, navigate, location.pathname);

    const tour = new Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true,
        },
      },
      useModalOverlay: true,
      steps,
    });

    tour.start();
  };

  return (
    <SgwtHelpCenter
      applicationId="end-user-computing"
      mailSubject="[EUC] User message"
      introductionTour={true}
      onTourStart={startTour}
    />
  );
};
